import React from 'react';
import { Container, makeStyles } from '@material-ui/core';
import Page from '../../../components/Layout/Page';
import Header from './Header';
import CommentsCreateForm from './CommentsCreateForm';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));

function CommentsCreateView() {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="TubeOps | Agregar comentario"
    >
      <Container maxWidth={false}>
        <Header />
        <CommentsCreateForm />
      </Container>
    </Page>
  );
}

export default CommentsCreateView;
